export const defaultTenantHost = import.meta.env.VITE_GBO_DEFAULT_HOST || "wolfe-propane";
export const apiBaseUrl = (
  import.meta.env.VITE_GBO_API_BASE_URL || "https://api.gasbill.online"
).replace(/\/$/, "");

export type AppEnv = "Local" | "Development" | "Production";

export function isLocalHost(hostname = window.location.hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
}

export function getAppEnv(hostname = window.location.hostname): AppEnv {
  if (isLocalHost(hostname)) return "Local";

  if (hostname.includes("testgasbill.online")) return "Development";

  if (hostname.includes("gasbill.online")) return "Production";

  return "Development";
}

export function isInAppEnv(...envs: AppEnv[]) {
  return envs.includes(getAppEnv());
}
